import { ChangeDetectorRef, Component, forwardRef, HostBinding, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { iValidatedControl } from '../iValidatedControl';
import { BaseCustomControl } from '../baseCustomControl';
import { ListItem } from '../../model/listItem';

@Component({
  selector: 'app-radio-group',
  templateUrl: './radio-group.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioGroup),
      multi: true,
    },
  ],
})
export class RadioGroup extends BaseCustomControl implements ControlValueAccessor, iValidatedControl {
  @HostBinding('class.formField') formFieldClass = true;
  @HostBinding('class.readOnly') get isReadOnly() {
    return this.readonly;
  }

  @Input() options: ListItem[] = [];
  @Input() displayDirection: string = 'horizontal'; // horizontal | vertical
  @Input() name: string = '';

  constructor(changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }

  get radioName(): string {
    return this.name || this.myId;
  }

  override clear() {
  }

  optionId(item: ListItem): string {
    return `${this.myId}-${item.id}`;
  }

  handleOnChanged(value: string) {
    this.boundValue = value;
    this.onChange(value);
    this.onChanged.emit(value);
  }

  validate(): boolean {
    this.isValid = true;
    this.validationMsg = '';

    if (this.required && (this.boundValue == null || this.boundValue === '')) {
      this.isValid = false;
      this.validationMsg = 'required';
      this._handle_validateFailed();
    } else {
      this._handle_validatePassed();
    }

    return this.isValid;
  }
}
